/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React from 'react';

import { useSpecsGridStyles } from './SpecsGrid.styles';

type SpecsGridProps = {
  specs: Array<{ name: string; value: string | number }>;
};

export function SpecsGrid(props: SpecsGridProps) {
  const classes = useSpecsGridStyles();

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        {props.specs.map((spec, key) => (
          <div className={classes.spec} key={[key, spec.name].join('_')}>
            <div className={classes.specName}>{spec.name}</div>
            <div className={classes.specValue}>{spec.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
